import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICES } from '../../config/config';
import { UserService } from '../user/user.service';
import { User } from '../../models/user.model';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Injectable()
export class TrabajosService {

  constructor( public http: HttpClient, public _userService: UserService ) { }

  crearTrabajo(trabajo: any) {
    let url = URL_SERVICES + '/trabajo?token=' + this._userService.token;
    return this.http.post(url, trabajo).map((resp: any) => {
      return resp.trabajo;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getTrabajo(inscripto: User) {
    let url = URL_SERVICES + '/trabajo/' + inscripto._id + '?token=' + this._userService.token;

    return this.http.get(url).map((res: any) => {
      return res.trabajo;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getTrabajoConCategoria(inscripto: User) {
    let url = URL_SERVICES + '/trabajo/concategoria/' + inscripto._id + '?token=' + this._userService.token;

    return this.http.get(url).map((res: any) => {
      return res.trabajo;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  reiniciarTrabajo(id: string) {
    let url = URL_SERVICES + '/trabajo/reiniciar/' + id + '?token=' + this._userService.token;
    return this.http.put(url, {}).map((resp: any) => {
      return resp.user;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getTrabajoPorCongreso(congreso_id: string) {
    let url = URL_SERVICES + '/trabajo/congreso/' + congreso_id + '?token=' + this._userService.token;

    return this.http.get(url).map((res: any) => {
      return res.trabajos;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getTrabajoPorCongresoTodos(congreso_id: string) {
    let url = URL_SERVICES + '/trabajo/congreso/todos/' + congreso_id + '?token=' + this._userService.token;

    return this.http.get(url).map((res: any) => {
      return res.trabajos;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getTrabajoPorCongresoCateg(congreso_id: string, categ_id: string) {
    let url = URL_SERVICES + '/trabajo/congresocateg/' + congreso_id + '/' + categ_id + '?token=' + this._userService.token;

    return this.http.get(url).map((res: any) => {
      return res.trabajos;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  getTrabajoPorCongresoCategTodos(congreso_id: string, categ_id: string) {
    let url = URL_SERVICES + '/trabajo/congresocateg/todos/' + congreso_id + '/' + categ_id + '?token=' + this._userService.token;

    return this.http.get(url).map((res: any) => {
      return res.trabajos;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

  guardarCodigoTrabajo(trabajo_id: string, codigo_trabajo: string) {
    let url = URL_SERVICES + '/trabajo/codigo/' + trabajo_id + '?token=' + this._userService.token;

    return this.http.put(url, { codigoTrabajo: codigo_trabajo }).map((res: any) => {
      return res.trabajo;
    })
    .catch(err => {
      console.log(err);
      if (err.status === 401) {
        swal('Error sesion expirada', 'Inicie sesión nuevamente por favor.', 'error');
        this._userService.logout();
      }
      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/trabajos/trabajos.service.ts